var categoryKc = {
    categoryCard: function () {
        let btnSeeMore = $('.js-kc-page-see-more__button');
        btnSeeMore.on('click',function() {
            $('.c-kc-page-categories__wrapper a').removeClass('is-hidden').addClass('is-visible');
            btnSeeMore.hide();
        })
    },
}

$(function () {

    if ($('.js-kc-page').length) {
        categoryKc.categoryCard();
    }
})


if ($('.kc-teaser-home-preview__img').length) {
    $('.kc-teaser-home-preview__img').on('click', function () {
        href = $(this).next('.kc-teaser-home-preview__content').find('.kc-teaser-home-preview__title').attr('href');
        window.location.href = href;
    });
}

if ($('.c-kc-teaser-preview__img').length) {
    $('.c-kc-teaser-preview__img').on('click', function () {
        href = $(this).next('.c-kc-teaser-preview__content').find('.c-kc-teaser-preview__title').attr('href');
        var target = $(this).next('.c-kc-teaser-preview__content').find('.c-kc-teaser-preview__title').attr('target');
        if(target=="_blank"){
            window.open(href, '_blank');
        }else{
            window.location.href = href;
        }
    });
}